<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0 login-row">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <b-img
          :src="appLogoImageWhite"
          class="logo-white"
          alt="logo"
        />
        <b-img
          :src="appLogoImageBlue"
          class="logo-blue"
          alt="logo"
        />
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5 auth-bg"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            class="login-placeholder"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center px-2 p-lg-5 bg-color-auth-form"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto auth-form"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1 text-white"
          >
            Welcome to x7trade!
          </b-card-title>
          <b-card-text class="mb-2 text-white">
            Please sign-in to your account
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                label="Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="john@example.com"
                    data-cy="login-email"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                  <b-link
                    :to="{name:'forgot-password'}"
                    tabindex="-1"
                  >
                    <small class="f-color text-white">Forgot Password?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                      data-cy="login-password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="rememberMe"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                :disabled="loading"
                type="submit"
                block
                class="text-white btn-color"
                @click="validationForm"
              >
                Sign in
                <b-spinner
                  v-if="loading"
                  small
                  class="ml-1"
                ></b-spinner>
              </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <span class="text-white">New on our platform? </span>
            <b-link
              href="https://www.feeport.eu/contact-us/"
              target="_blank"
            >
              <span class="f-color text-white font-weight-bold">&nbsp;Request Contact</span>
            </b-link>
          </b-card-text>

        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { $themeConfig } from '@themeConfig'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import { login, logout, setUserData } from '@/auth/sanctum'
import router from '@/router'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  setup() {
    // App Name
    const { appLogoImage, appLogoImageWhite, appLogoImageBlue } = $themeConfig.app

    return {
      appLogoImage,
      appLogoImageWhite,
      appLogoImageBlue,
    }
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      password: '',
      userEmail: '',
      rememberMe: '',
      sideImg: require('@/assets/images/pages/login_placeholder_blue_theme.svg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      loading: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login_placeholder_blue_theme.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    async refreshUserData() {
      this.$activeCompany().fetchCompany()
      if (!await this.$activeCompany().data.company) {
        logout()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'You do not have a company assigned to you.',
            icon: 'EditIcon',
            variant: 'danger',
          },
        })
      }
      await this.$classifiers().fetchClassifiers()
      await this.$permissions().fetchAccess()
      if (!this.$permissions().hasAnyPermissions()) {
        logout()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'You do not enough permissions to view anything.',
            icon: 'EditIcon',
            variant: 'danger',
          },
        })
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Login successful',
            icon: 'EditIcon',
            variant: 'success',
          },
        })
        const location = this.$route.query.redirect && !this.$route.query.redirect.includes('login')
          ? this.$route.query.redirect
          : '/'
        await router.push(location) // Refresh
      }
    },
    validationForm() {
      this.$refs.loginValidation.validate().then(success => {
        if (!success) {
          return
        }

        this.loading = true
        login(this.$data.userEmail, this.$data.password, this.$data.rememberMe)
          .then(response => {
            setUserData(response.data.user)
            this.$profile().fetchProfile(this.refreshUserData)
          })
          .catch(error => {
            this.loading = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.response.data.message,
                icon: 'EditIcon',
                variant: 'danger',
              },
            })
          })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
